module.exports = {"buildDate":"28 Nov 2025","buildNumber":15}


//////////////////
// WEBPACK FOOTER
// ./src/build-info.json
// module id = 1745
// module chunks = 1